﻿import React, {FC} from 'react';
import {
  CollapsableCardBodyItemContainer,
  CollapsableCardLabel,
  CollapsableCardValue
} from "@securspace/securspace-ui-kit";
import {SlotType} from "../../types/Slots";
import {useSlotOrDefault} from "../../hooks/slots/useSlotOrDefault";

// OverridableComponent interface is broken in this repo, manually extended Grid Props
type CollapsableCardHeaderItemProps = React.ComponentPropsWithoutRef<'div'> & {
  value: SlotType
  label: SlotType
}

const CollapsableCardHeaderItem: FC<CollapsableCardHeaderItemProps> = ({value, label, ...rest}) => {
  // define slots
  const Label = useSlotOrDefault(label, CollapsableCardLabel);
  const Value = useSlotOrDefault(value ?? '-', CollapsableCardValue);

  return <CollapsableCardBodyItemContainer {...rest}>
    {Label}
    {Value}
  </CollapsableCardBodyItemContainer>
}

export { CollapsableCardHeaderItem };
